import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationComponent } from './pagination/pagination.component';
import { MemberService } from './services/member.service';
import { PlanningService } from './services/planning.service';
import { SeasonService } from './services/season.service';
import { SessionShortDescComponent } from './session-short-desc/session-short-desc.component';


@NgModule({
  declarations: [PaginationComponent, SessionShortDescComponent],
  imports: [
    CommonModule
  ],
  exports: [
    PaginationComponent, SessionShortDescComponent
  ],
  providers: [
    MemberService, MemberService, SeasonService
  ]
})
export class SharedModule { }
